const fileToBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve({ data: reader.result, name: file.name, pureBase64: String(reader.result).split(";base64,")[1] });
  reader.onerror = error => reject(error);
});

export default fileToBase64;
